import { render, staticRenderFns } from "./term_of_use.vue?vue&type=template&id=7bc66068&scoped=true&"
import script from "./term_of_use.vue?vue&type=script&lang=js&"
export * from "./term_of_use.vue?vue&type=script&lang=js&"
import style0 from "./term_of_use.vue?vue&type=style&index=0&id=7bc66068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc66068",
  null
  
)

export default component.exports